<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model="identificadorPaginaLocale"
        dense
        outlined
        validate-on-blur
        label="Identificador da página"
        hint="Máximo de 300 caracteres"
        :loading="loading"
        :rules="[validators.required, v => (!!v && v.length <= 300) || 'Máximo de 300 caracteres']"
        @change="v => $emit('update:identificadorPagina', v)"
      />
    </v-col>

    <v-col cols="12">
      <v-textarea
        v-model="tokenAcessoPaginaLocale"
        dense
        outlined
        no-resize
        validate-on-blur
        label="Token de acesso à página"
        hint="Máximo de 1000 caracteres"
        :loading="loading"
        :rules="[validators.required, v => (!!v && v.length <= 1000) || 'Máximo de 1000 caracteres']"
        @change="v => $emit('update:tokenAcessoPagina', v)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { required } from '@core/utils/validation'

export default {
  emits: ['update:identificadorPagina', 'update:tokenAcessoPagina'],

  props: {
    canalData: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const identificadorPaginaLocale = ref(null)
    const tokenAcessoPaginaLocale = ref(null)

    watch(
      () => props.canalData,
      v => {
        identificadorPaginaLocale.value = v?.identificadorPagina || null
        tokenAcessoPaginaLocale.value = v?.tokenAcessoPagina || null
      },
      { immediate: true },
    )

    return {
      identificadorPaginaLocale,
      tokenAcessoPaginaLocale,
      validators: {
        required,
      },
    }
  },
}
</script>
